export default {
  paymentResult: {
    pageTitle: "Payment {status}",
    error: {
      message: {
        paymentUnsuccessful:
          "We had an issue processing your payment. Please try again later.",
        paymentCancelled:
          "You have cancelled your payment. Please try again if you would like to complete the purchase.",
        systemError: "Something went wrong. Please try again later.",
      },
    },
    button: {
      back: {
        text: "Back",
      },
      tryAgain: {
        text: "Try again",
      },
      continue: {
        text: "Continue",
      },
    },
    paymentStatus: {
      successful: "Successful",
      unsuccessful: "Unsuccessful",
    },
    title: {
      transactionHistory: "Transaction History",
      receiptNo: "Reference No",
      dateTime: "Date & Time",
      paymentType: "Payment Type",
      paymentDescription: "Payment Description",
      status: "Status",
      totalAmount: "Total Amount ({currency})",
    },
    receiptDownloadText:
      "*Your receipt will be available for download in Payment History when it's ready",
    creditBrickzText:
      "*Your credits/add-on purchase will be reflected in your account shortly.",
  },
};
